import { render } from "./TooltipUsername.vue?vue&type=template&id=af476bda&scoped=true"
import script from "./TooltipUsername.vue?vue&type=script&lang=js"
export * from "./TooltipUsername.vue?vue&type=script&lang=js"

import "./TooltipUsername.vue?vue&type=style&index=0&id=af476bda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af476bda"]])

export default __exports__